const NotFound = () => {
  return <div>404 Error - Page not found</div>;
};

export default NotFound;
